import {
	Collapse,
	Divider,
	HStack,
	Icon,
	IconButton,
	Text,
	useDisclosure,
	VStack,
	Box,
	Flex,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import React from 'react'

import {
	BiMessageDetail,
	BiMessageCheck,
	BiChevronDown,
	BiChevronUp,
} from 'react-icons/bi'
import { sectionDetailedTrack } from '../../../containers/repository/repo.utils'
import { useUpdateReadStatus } from '../../../hooks/broadcast.hooks'
import { GA_CATEGORY_FILES } from './../../../containers/repository/repo.utils'
import { convertPound, convertUnicode } from '../../../utils/linkInText.utils'

const BroadCastItem = ({ msg, index, refresh, refreshMsg }) => {
	const { mutate } = useUpdateReadStatus()
	const { isOpen: expand, onToggle } = useDisclosure()

	const onExpand = d => {
		mutate(
			{
				broadcast_id: d.broadcast_id,
				broadcast_flag_read: 1,
				flag: 1,
			},
			{
				onSuccess: async res => {
					refresh()
					setTimeout(() => {
						refreshMsg()
					}, 500)
				},
			}
		)
	}

	return (
		<HStack
			justifyContent='space-between'
			boxShadow='0px 2px 10px rgba(24, 39, 75, 0.12)'
			bg='#FFFFFF'
			key={index}
			borderRadius='5px'
			w='full'
			px={2}
		>
			<VStack
				flex={1}
				p={2}
				alignItems='flex-start'
				wordBreak='break-all'
				overflow='hidden'
			>
				<Flex>
					<Box>
						<IconButton
							onClick={() => {
								sectionDetailedTrack({
									category: GA_CATEGORY_FILES,
									action: 'Broadcast Items',
									label: 'Expand Message',
								})
								if (msg.broadcast_flag_read === 0) {
									onExpand(msg)
								}
							}}
							icon={
								<Icon
									as={
										msg.broadcast_flag_read ? BiMessageCheck : BiMessageDetail
									}
									h={6}
									w={6}
								/>
							}
							bg=''
							color='green.400'
							_focus={{
								color: 'green.400',
							}}
							_hover={{
								color: msg.broadcast_flag_read ? 'green.400' : 'white',
								bg: msg.broadcast_flag_read ? '' : 'green.400',
							}}
							_active={{
								color: 'white',
								bg: 'green.400',
							}}
							cursor={msg.broadcast_flag_read ? 'default' : 'pointer'}
						/>
					</Box>
					<Box ml='20px'>
						<Flex
							justifyContent='space-between'
							mb='3px'
							cursor='pointer'
							onClick={() => {
								onToggle()
							}}
						>
							<Text
								fontSize='14px'
								fontWeight='400'
								m={0}
								p={0}
								color='brand.700'
								textTransform='capitalize'
							>
								{msg.broadcast_subject}
							</Text>
							<Icon
								as={expand ? BiChevronUp : BiChevronDown}
								color='brand.700'
								w={5}
								h={5}
							/>
						</Flex>
						<Collapse startingHeight={20} in={expand} w='100%'>
							<Text
								textAlign='left'
								style={{ margin: '0 !important' }}
								fontSize='12px'
								color='gray.400'
								fontWeight='500'
								dangerouslySetInnerHTML={{
									__html: convertPound(
										convertUnicode(unescape(msg.broadcast_content))
									),
								}}
							/>
						</Collapse>
					</Box>
				</Flex>
				<Divider />
				<HStack justifyContent='flex-end' alignItems='center' w='full'>
					<Text fontSize='11px' fontWeight='400' color='#969696'>
						{format(
							new Date(msg.log_datetime.split(' ').join('T')),
							'dd MMM yyyy | HH:mm'
						)}
					</Text>
				</HStack>
			</VStack>
		</HStack>
	)
}

export default BroadCastItem
